import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const Thankyou = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: { xs: "2rem", sm: "3rem" },
        backgroundColor: "#F5F5F5",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <Typography 
          component="h1" 
          variant="h4" 
          gutterBottom
          sx={{
            fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.5rem" },
            fontWeight: { xs: 300, sm: 300, md: 600 },
            color: "#000000",
            marginBottom: "1.5rem",
            fontFamily: '"Bebas Neue", sans-serif'
          }}
        >
          Thank You for Reaching Out!
        </Typography>
        <Typography 
          variant="body1" 
          sx={{ 
            maxWidth: "500px", 
            marginBottom: "3rem",
            fontSize: { xs: "1rem", sm: "1.1rem", md: "1.2rem" },
            lineHeight: 1.6,
            color: "#000000",
            fontFamily: '"Old Standard TT", serif',
            fontWeight: { xs: 300, sm: 300, md: 400 }
          }}
        >
          We appreciate your message and will get back to you as soon as we can.
        </Typography>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={() => navigate("/")}
          sx={{
            padding: "0.8rem 2rem",
            fontSize: "1.1rem",
            textTransform: "none",
            transition: "all 0.3s ease-in-out",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            },
          }}
        >
          Return Home
        </Button>
      </motion.div>
    </Box>
  );
};

export default Thankyou;
